import * as React from 'react';

import classNames from 'classnames';

import { MainMenuBalance } from '@components';

import { IMainMenuUserProps } from './types';

import * as s from './MainMenuUserHuge.scss';

export const MainMenuUserHuge: React.FC<IMainMenuUserProps> = ( props: IMainMenuUserProps ) => {
	const {
		className,
		name,
		avatar,
		balance,
	} = props;

	return (
		<div className={classNames(s.block, className)}>
			<span className={s.avatar} style={{ backgroundImage: `url(${avatar})` }}/>
			<span className={s.title}>{name}</span>
			<MainMenuBalance className={s.balance} balance={balance || 0} innerMargin={5}/>
		</div>
	);
};
